<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <h1 class="title-default">Notas Fiscais</h1>
        <p class="welcome-message">Bem vindo ao módulo <span class="display-name">Notas Fiscais</span>! Aqui você
            encontra
            suas notas de saída e de entrada.</p>
        <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
    </div>
</div>